import { jsPDF } from "jspdf";

// Todo PDF se abre en otra pestaña, desde ahi se puede imprimir o descargar.
// Si el navegador bloquea la ventana, se descarga como antes.
jsPDF.API.save = function (nombre) {
  const archivo = nombre || "documento.pdf";
  this.setProperties({ title: archivo.replace(/\.pdf$/i, "") });
  const url = URL.createObjectURL(this.output("blob"));
  if (!window.open(url, "_blank")) {
    const liga = document.createElement("a");
    liga.href = url;
    liga.download = archivo;
    liga.click();
  }
  setTimeout(() => URL.revokeObjectURL(url), 120000);
  return this;
};

/**
 * pdfUtils.js: plantilla unica de los PDF de Kosher Vinos.
 *
 * Listados:
 *   const inicio = pdfHeader(doc, "Listado de Abonos", "2026-01-01 al 2026-10-30");
 *   doc.autoTable({ ...pdfTableStyles(), head, body, foot, startY: inicio });
 *   pdfFooter(doc);
 *
 * Documentos (nota, orden, recibo):
 *   const inicio = pdfDocumento(doc, { titulo, folio, fecha, datos: [{ titulo, lineas }] });
 *   doc.autoTable({ ...pdfTableStyles(), head, body, startY: inicio });
 *   pdfTotales(doc, [["Subtotal", "$100.00"], ["Total", "$116.00"]]);
 *   pdfFooter(doc);
 */

const C = {
  marca: [15, 23, 42],     // #0f172a titulos y lineas
  texto: [30, 41, 59],     // #1e293b
  medio: [71, 85, 105],    // #475569
  tenue: [148, 163, 184],  // #94a3b8
  linea: [226, 232, 240],  // #e2e8f0
};

const NOMBRE = process.env.REACT_APP_NOMBRE_INSTITUCION || "Kosher Vinos";
const TELEFONO = process.env.REACT_APP_TELEFONO_INSTITUCION || "";

// Precargado: jsPDF necesita la imagen ya descargada
const LOGO = typeof Image !== "undefined" ? new Image() : null;
if (LOGO) LOGO.src = `${process.env.PUBLIC_URL}/logoInstitucion.png`;

export const fmtMoney = (v, decimales = 2) =>
  "$" + new Intl.NumberFormat("en-US", { minimumFractionDigits: decimales, maximumFractionDigits: decimales }).format(Number(v) || 0);
export const fmtMXN = (v) => fmtMoney(v, 0);

const ALTO_BANDA = 30;

// Encabezado sin relleno para ahorrar tinta: logo, empresa y una linea fina
function banda(doc) {
  const W = doc.internal.pageSize.getWidth();
  if (LOGO && LOGO.complete && LOGO.naturalWidth) {
    try { doc.addImage(LOGO, "PNG", 11, 5, 21, 21); } catch (_) { /* sigue sin logo */ }
  }
  doc.setFont("helvetica", "bold");
  doc.setFontSize(13);
  doc.setTextColor(...C.marca);
  doc.text(NOMBRE, 35, 14);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.setTextColor(...C.medio);
  doc.text(["Vinos kosher", TELEFONO ? `Tel. ${TELEFONO}` : ""].filter(Boolean).join("  ·  "), 35, 19.5);
  doc.setDrawColor(...C.marca);
  doc.setLineWidth(0.4);
  doc.line(12, ALTO_BANDA, W - 12, ALTO_BANDA);
  return W;
}

/** Encabezado de listados y reportes. Regresa el startY de la tabla. */
export function pdfHeader(doc, title, subtitle = "") {
  const W = banda(doc);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.setTextColor(...C.marca);
  doc.text(String(title), W - 12, 13, { align: "right" });
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.setTextColor(...C.medio);
  if (subtitle) doc.text(String(subtitle), W - 12, 19, { align: "right" });
  doc.text(`Generado ${new Date().toLocaleDateString("es-MX", { day: "2-digit", month: "short", year: "numeric" })}`, W - 12, 24.5, { align: "right" });
  return ALTO_BANDA + 7;
}

/**
 * Encabezado de documentos con folio y tarjetas de datos.
 * datos: [{ titulo: "Proveedor", lineas: ["Nombre", "Plazo 30 dias"] }]
 */
export function pdfDocumento(doc, { titulo, folio, fecha, datos = [], qr }) {
  const W = banda(doc);
  if (qr) {
    try { doc.addImage(qr, "PNG", W - 12 - 98, 5.5, 19, 19); } catch (_) { /* sigue sin qr */ }
  }
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.setTextColor(...C.marca);
  doc.text(String(titulo).toUpperCase(), W - 12, 13, { align: "right" });
  doc.setFontSize(10);
  doc.setTextColor(...C.marca);
  if (folio !== undefined && folio !== "") doc.text(`Folio ${folio}`, W - 12, 19.5, { align: "right" });
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.setTextColor(...C.medio);
  if (fecha) doc.text(String(fecha), W - 12, 24.5, { align: "right" });

  let y = ALTO_BANDA + 6;
  if (datos.length) {
    const gap = 4;
    const ancho = (W - 24 - gap * (datos.length - 1)) / datos.length;
    const lineas = datos.map((d) => {
      doc.setFontSize(8.5);
      return d.lineas.filter((l) => l !== undefined && l !== null && l !== "").flatMap((l) => doc.splitTextToSize(String(l), ancho - 8));
    });
    const alto = 10 + Math.max(...lineas.map((l) => l.length)) * 4.2;
    datos.forEach((d, i) => {
      const x = 12 + i * (ancho + gap);
      doc.setDrawColor(...C.linea);
      doc.setLineWidth(0.25);
      doc.roundedRect(x, y, ancho, alto, 1.2, 1.2, "S");
      doc.setFont("helvetica", "bold");
      doc.setFontSize(7);
      doc.setTextColor(...C.medio);
      doc.text(String(d.titulo).toUpperCase(), x + 4, y + 5.5);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8.5);
      doc.setTextColor(...C.texto);
      lineas[i].forEach((l, j) => doc.text(l, x + 4, y + 10.5 + j * 4.2));
    });
    y += alto + 6;
  }
  return y;
}

/** Caja de totales a la derecha, abajo de la ultima tabla. La ultima fila se resalta. */
export function pdfTotales(doc, filas, opciones = {}) {
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();
  const ancho = opciones.ancho || 72;
  let y = opciones.y || doc.lastAutoTable.finalY + 5;
  if (y + filas.length * 6.5 + 4 > H - 18) { doc.addPage(); y = 16; }
  const x = W - 12 - ancho;
  filas.forEach(([etiqueta, valor], i) => {
    const ultima = i === filas.length - 1;
    if (ultima) {
      doc.setDrawColor(...C.marca);
      doc.setLineWidth(0.4);
      doc.line(x, y + 0.2, x + ancho, y + 0.2);
      doc.line(x, y + 8, x + ancho, y + 8);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.setTextColor(...C.marca);
      doc.text(String(etiqueta), x + 3, y + 5.5);
      doc.text(String(valor), x + ancho - 3, y + 5.5, { align: "right" });
      y += 8;
    } else {
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8.5);
      doc.setTextColor(...C.medio);
      doc.text(String(etiqueta), x + 3, y + 4.4);
      doc.setTextColor(...C.texto);
      doc.text(String(valor), x + ancho - 3, y + 4.4, { align: "right" });
      doc.setDrawColor(...C.linea);
      doc.setLineWidth(0.15);
      doc.line(x, y + 6.5, x + ancho, y + 6.5);
      y += 6.5;
    }
  });
  return y;
}

/** Texto pequeño (condiciones, pagare) con titulo opcional. Regresa el y siguiente. */
export function pdfNota(doc, texto, { titulo, y, ancho } = {}) {
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();
  const lineas = doc.splitTextToSize(String(texto), ancho || W - 24);
  let yy = y || doc.lastAutoTable.finalY + 8;
  if (yy + lineas.length * 3.4 + 6 > H - 18) { doc.addPage(); yy = 16; }
  if (titulo) {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7.5);
    doc.setTextColor(...C.marca);
    doc.text(String(titulo).toUpperCase(), 12, yy);
    yy += 4;
  }
  doc.setFont("helvetica", "normal");
  doc.setFontSize(7.5);
  doc.setTextColor(...C.medio);
  doc.text(lineas, 12, yy);
  return yy + lineas.length * 3.4 + 3;
}

/** Lineas de firma al final del documento. */
export function pdfFirmas(doc, etiquetas, y) {
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();
  let yy = y + 16;
  if (yy + 8 > H - 18) { doc.addPage(); yy = 30; }
  const gap = 12;
  const ancho = (W - 24 - gap * (etiquetas.length - 1)) / etiquetas.length;
  etiquetas.forEach((e, i) => {
    const x = 12 + i * (ancho + gap);
    doc.setDrawColor(...C.medio);
    doc.setLineWidth(0.25);
    doc.line(x, yy, x + ancho, yy);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(7.5);
    doc.setTextColor(...C.medio);
    doc.text(String(e), x + ancho / 2, yy + 4, { align: "center" });
  });
  return yy + 8;
}

const VACIO = (v) => v === undefined || v === null || v === "" || v === "NA" || v === "undefined";

/** Junta las partes de una direccion omitiendo las vacias o "NA". */
export const pdfDireccion = (...partes) => partes.filter((p) => !VACIO(p) && String(p) !== "0").join(" ");

/** Lineas de la tarjeta Cliente. */
export const pdfCliente = (nombre, telefono, direccion, ...extra) => [
  nombre,
  VACIO(telefono) ? "" : `Tel. ${telefono}`,
  direccion,
  ...extra,
];

export const NOTA_CONDICIONES = [
  "1. Esta es una venta en firme y no se acepta ningún tipo de descuento o devolución sin consentimiento previo.",
  "2. La mercancía viaja por cuenta y riesgo del cliente, no somos responsables por faltante.",
  "3. El pago de la mercancía debe realizarse en tiempo y forma pactados a la cuenta proporcionada por nosotros.",
].join("\n");

export const NOTA_PAGARE =
  "Debo(emos) y pagare(mos) incondicionalmente por este pagare a la orden de KOSHER VINOS en esta plaza, el día estipulado en este documento, la cantidad estipulada en este documento, valor recibido a mi entera satisfacción, este pagare causará intereses a razón de 2% mensual a partir de la fecha de vencimiento, hasta su total liquidación, pagadero conjuntamente con el principal. Este pagare se rige en los términos de ley general de títulos y operaciones de crédito.";

export const NOTA_LEYENDA = "ESTE DOCUMENTO NO REPRESENTA UN COMPROBANTE FISCAL";

/** Filas de totales de una nota: omite los conceptos en 0, menos el Total. */
export function pdfFilasTotales({ botellas, cajas, subTotal, descuento, descuentoPct, flete, ieps, iva, total }) {
  const entero = (v, dec = 0) => new Intl.NumberFormat("en-US", { maximumFractionDigits: dec }).format(Number(v) || 0);
  const filas = [];
  if (Number(botellas)) filas.push(["Botellas", entero(botellas)]);
  if (Number(cajas)) filas.push(["Cajas", entero(cajas, 2)]);
  if (Number(subTotal)) filas.push(["Subtotal", fmtMoney(subTotal)]);
  if (Number(descuento)) filas.push([Number(descuentoPct) ? `Descuento ${descuentoPct}%` : "Descuento", `-${fmtMoney(descuento)}`]);
  if (Number(flete)) filas.push(["Flete", fmtMoney(flete)]);
  if (Number(ieps)) filas.push(["IEPS", fmtMoney(ieps)]);
  if (Number(iva)) filas.push(["IVA", fmtMoney(iva)]);
  filas.push(["Total", fmtMoney(total)]);
  return filas;
}

/**
 * Nota de venta o pedido completo: encabezado, tabla, totales, condiciones y firmas.
 * Con foto: true la primera columna de body trae la imagen del vino.
 */
export function pdfNotaVenta(doc, {
  titulo, folio, fecha, cliente = [], datos = [], head, body, foto = false, totales = [],
  observaciones, condiciones, pagare, firmas = ["Nombre completo", "Firma"], leyenda,
}) {
  const tarjetas = [{ titulo: "Cliente", lineas: cliente }];
  if (datos.length) tarjetas.push({ titulo: "Datos", lineas: datos });
  const inicio = pdfDocumento(doc, { titulo, folio, fecha, datos: tarjetas });

  const base = pdfTableStyles();
  const tabla = { ...base, startY: inicio, head: [head], body };
  if (foto) {
    tabla.columnStyles = { 0: { cellWidth: 20, minCellHeight: 20 } };
    tabla.didParseCell = (data) => {
      base.didParseCell(data);
      if (data.column.index === 0 && data.section === "body") data.cell.text = [""];
    };
    tabla.didDrawCell = (data) => {
      if (data.column.index !== 0 || data.section !== "body" || !data.cell.raw) return;
      try {
        doc.addImage(data.cell.raw, data.cell.x + 1, data.cell.y + 1, 18, 18);
      } catch (_) { /* renglon sin foto */ }
    };
  }
  doc.autoTable(tabla);

  let y = pdfTotales(doc, totales) + 7;
  if (!VACIO(observaciones)) y = pdfNota(doc, observaciones, { titulo: "Observaciones", y });
  if (condiciones) y = pdfNota(doc, condiciones, { titulo: "Condiciones", y });
  if (pagare) y = pdfNota(doc, pagare, { titulo: "Pagaré", y });
  y = pdfFirmas(doc, firmas, y) + 5;
  if (leyenda) {
    const H = doc.internal.pageSize.getHeight();
    if (y > H - 18) { doc.addPage(); y = 16; }
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7.5);
    doc.setTextColor(...C.medio);
    doc.text(leyenda, doc.internal.pageSize.getWidth() / 2, y, { align: "center" });
    y += 4;
  }
  return y;
}

/** Documento con tabla: encabezado, tarjetas, tabla, totales, observaciones y firmas. */
export function pdfDocumentoTabla(doc, {
  titulo, folio, fecha, datos = [], qr, head, body, totales = [],
  observaciones, tituloObservaciones = "Observaciones", firmas,
}) {
  const inicio = pdfDocumento(doc, { titulo, folio, fecha, datos, qr });
  doc.autoTable({ ...pdfTableStyles(), startY: inicio, head: [head], body });
  let y = pdfTotales(doc, totales) + 7;
  if (!VACIO(observaciones) && String(observaciones).trim() !== "") {
    y = pdfNota(doc, observaciones, { titulo: tituloObservaciones, y });
  }
  if (firmas && firmas.length) y = pdfFirmas(doc, firmas, y);
  return y;
}

/** Pie con numeracion. Va despues de la ultima tabla y antes de save/output. */
export function pdfFooter(doc) {
  const total = doc.internal.getNumberOfPages();
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();
  for (let i = 1; i <= total; i++) {
    doc.setPage(i);
    doc.setDrawColor(...C.linea);
    doc.setLineWidth(0.2);
    doc.line(12, H - 11, W - 12, H - 11);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(7);
    doc.setTextColor(...C.tenue);
    doc.text(NOMBRE, 12, H - 6.5);
    doc.text("Powered by Lynqro", W / 2, H - 6.5, { align: "center" });
    doc.text(`Pagina ${i} de ${total}`, W - 12, H - 6.5, { align: "right" });
  }
}

const ES_NUMERO = /^\s*-?\$?\s*-?[\d,]+(\.\d+)?\s*(%|USD|MXN)?\s*$/;

/** Base de tablas: lineas horizontales, zebra suave y numeros alineados a la derecha. */
export function pdfTableStyles(extraHeadStyles = {}, extraBodyStyles = {}) {
  return {
    theme: "plain",
    styles: {
      fontSize: 8,
      cellPadding: { top: 2.2, right: 3, bottom: 2.2, left: 3 },
      font: "helvetica",
      textColor: C.texto,
      lineColor: C.linea,
      lineWidth: { bottom: 0.15 },
      overflow: "linebreak",
      valign: "middle",
    },
    headStyles: {
      textColor: C.marca,
      fontStyle: "bold",
      fontSize: 7.5,
      lineColor: C.marca,
      lineWidth: { top: 0.3, bottom: 0.3 },
      ...extraHeadStyles,
    },
    footStyles: {
      textColor: C.marca,
      fontStyle: "bold",
      fontSize: 8.2,
      lineColor: C.marca,
      lineWidth: { top: 0.3 },
    },
    margin: { left: 12, right: 12, bottom: 16, top: 14 },
    didParseCell: (data) => {
      const col = data.column.index;
      const fila = data.table.body.find((r) => r.raw && r.raw[col] !== undefined && r.raw[col] !== "");
      const muestra = fila ? fila.raw[col] : "";
      const numerica = typeof muestra === "number" || ES_NUMERO.test(String(muestra));
      if (numerica) data.cell.styles.halign = "right";
    },
    ...extraBodyStyles,
  };
}
